import { FC } from "react";
import SignUpForm from "../../components/Form/SignUpForm";

const SignUpPage: FC = () => {
  return <SignUpForm />;
};

export default SignUpPage;
